import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { Tag } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetAllTags() {
	return useQuery<Tag[]>({
		queryKey: ['get-all-tags-admin', schoolId],
		queryFn: async () => {
			const { data, error } = await supabase
				.from('tags')
				.select('tag_id, tag_color, tag_name, tag_definition, tag_discipline')
				.eq('school_id', schoolId)
				.order('tag_name', { ascending: true });

			if (error) throw error;

			return data as Tag[];
		},
		staleTime: Infinity,
	});
}

export function useGetTags() {
	return useQuery<Tag[]>({
		queryKey: ['get-all-tags', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('tags')
				.select('tag_id, tag_color, tag_name, tag_definition, tag_discipline')
				.eq('school_id', schoolId)
				.order('tag_name', { ascending: true });

			if (error) throw error;

			return (data ?? []) as Tag[];
		},

		staleTime: Infinity,
		refetchOnMount: 'always',
	});
}
